import APIconsume from 'Main/APIconsume'
import { minPageSizeConfigs } from 'Main/Utils'

const BASE_URL = '/api/dashboard/api-traffic'

class ApiTrafficLogsService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /**
   * GET /logs/api-traffic : replaces the server-rendered GET /dashboard/api-traffic
   * query-string filtering from apiTrafficLogs.ejs.
   */
  async getData (page = 1, size = minPageSizeConfigs, endpoint = '%', status = '%', from = '', to = '', userId = 'ALL') {
    const params = new URLSearchParams({ page, size, endpoint, status, from, to, user_id: userId }).toString()
    const result = await this._apiConsume.getData(`${BASE_URL}?${params}`)
    return result?.data
  }

  /** GET /logs/api-traffic/endpoints: distinct endpoint list for the filter dropdown. */
  async getEndpoints (userId = 'ALL') {
    const params = new URLSearchParams({ user_id: userId }).toString()
    const result = await this._apiConsume.getData(`${BASE_URL}/endpoints?${params}`)
    return result?.data
  }

  /** GET /logs/api-traffic/:id: single log detail (apiTrafficLogsDetail.ejs). */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

}

export default ApiTrafficLogsService
